var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableBody as MuiTableBody } from '@mui/material';
import React from 'react';
import TableDivider from './Table.Divider';
import TableExpandableRow from './Table.ExpandableRow';
import TableRow from './Table.Row';
export default function TableBody(props) {
    var columns = props.columns, data = props.data, config = props.config, variant = props.variant, collapsedRows = props.collapsedRows, toggleRowExpand = props.toggleRowExpand;
    var isExpandable = variant === 'expandable';
    var isAltered = variant === 'altered' && !isExpandable;
    return (_jsx(MuiTableBody, __assign({ datatype: variant }, { children: data.map(function (row, index) {
            var isLast = index === data.length - 1;
            var showDivider = !isLast && isAltered && !(config === null || config === void 0 ? void 0 : config.noDivider);
            return (_jsxs(React.Fragment, { children: [_jsx(TableRow, { index: index, toggleRowExpand: toggleRowExpand, collapsedRows: collapsedRows, row: row, config: config, columns: columns, variant: variant }), isExpandable && (_jsx(TableExpandableRow, { index: index, toggleRowExpand: toggleRowExpand, collapsedRows: collapsedRows, row: row, config: config })), showDivider && _jsx(TableDivider, {})] }, JSON.stringify(row)));
        }) })));
}
